module.exports = __webpack_public_path__ + "static/Durian-0ab87c9c1879d7ce5fdb3bef2318c511.png";